import { AppError } from './app-error.model';

export class IneligibleError extends AppError {

}